import { Component, ErrorInfo, ReactNode } from 'react';
import * as Sentry from '@sentry/nextjs';
interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}
interface State {
  hasError: boolean;
}
class SentryErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(): State {
    return {
      hasError: true
    };
  }
  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    Sentry.captureException(error, {
      contexts: {
        react: {
          componentStack: errorInfo.componentStack
        }
      },
      tags: {
        domain: window.location.hostname,
        'builder.component': error.message.includes('Builder') ? 'yes' : 'no',
        'feathery.form': error.message.includes('Feathery') ? 'yes' : 'no'
      }
    });
  }
  render(): ReactNode {
    if (this.state.hasError) {
      return this.props.fallback || <div className="error-boundary">
						<h2>Something went wrong</h2>
						<button onClick={() => window.location.reload()}>Refresh Page</button>
					</div>;
    }
    return this.props.children;
  }
}
export default SentryErrorBoundary;